import { createStore } from 'stimulus-store';

export const allDeploymentStatusesStore = createStore({
    name: 'allDeploymentStatusesStore',
    type: Array,
    initialValue: []
});